<script setup>
import BaseDashboardSidebar from '@/layout/base/BaseDashboardSidebar.vue';
import menuItems from '@/layout/main/menu';

const props = defineProps({
    class: {
        type: String,
        default: ''
    }
});
</script>

<template>
    <BaseDashboardSidebar 
        :class="props.class"
        :menu-items="menuItems"
        dashboard-route="client.dashboard"
    />
</template>